import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ProspectEditDraftPage } from './ProspectEditDraftPage'
import { withRouter, useLocation } from 'react-router-dom'

import {
  getProspectDsr,
  updatePdsr,
  resetDsrPages,
  resetDsrSelectedDisplaySubpage,
  resetDsrTitle,
  updatePdsrReset
} from '../../actions/dsr-actions'


const ProspectEditDraftPageContainer = (props) => {
  const location = useLocation();
  const isLiveEdit = (location.pathname.startsWith("/edit")) ? true : false;

  return <ProspectEditDraftPage {...props} isLiveEdit={isLiveEdit}/>
}

const mapStateToProps = (state) => ({
  dsrPagesRedux: state.setDsrPages.pages,
  dsrTitleRedux: state.dsrTitle.title,
  dsrInvalidRequestRedux: state.dsrInvalidRequest.request,
  dsrStatusRedux: state.dsrStatus.status,
  showDsrModalRedux: state.dsrModal.showDsrModal,
  userActionRequiredRedux: state.dsrPopup.UserActionRequired,
  showDsrModalLoaderRedux: state.showDsrModalLoader.show,
	isMobileView: state.mobileViewMode.isMobileView
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProspectDsr,
      resetDsrTitle,
      resetDsrSelectedDisplaySubpage,
      resetDsrPages,
      updatePdsrReset,
      updatePdsr
    },
    dispatch,
  )

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProspectEditDraftPageContainer),
)
